/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/shop_material";
import { Action as AuthAction } from "api/action_types/authentication";
import { Action as QuoteAction } from "api/action_types/shop_quote";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/shop_material";
import { ActionType as AuthActionType } from "api/action_types/authentication";
import { ActionType as QuoteActionType } from "api/action_types/shop_quote";
/// TYPES ///
import { IShopMaterial } from "api/types/shop_material";
/// URLS ///
import { shop_material_url } from "../../endpoint";
import { url_prefix } from "settings";

export const createShopMaterial = (material: IShopMaterial) => {
  return async (dispatch: Dispatch<Action | AuthAction | QuoteAction>, getState: () => RootState) => {

    const { user } = getState().authentication;

    dispatch({
      type: QuoteActionType.SHOP_QUOTE_UPDATING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const url = `${url_prefix}${shop_material_url}/`;

    try {
      const { data } = await axios.post(url, material, config);

      dispatch({
        type: ActionType.CREATE_SHOP_MATERIAL,
        material: data
      });

      dispatch({
        type: QuoteActionType.SHOP_QUOTE_ACTION_SUCCESS
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SHOP_MATERIAL_ERROR,
          error: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
